export enum Country {
  Germany = "de",
  UnitedKingdom = "uk",
  France = "fr",
  Netherlands = "nl",
}

export const COUNTRY_OPTIONS = [
  {
    value: Country.Germany,
    label: "Germany",
  },
  {
    value: Country.UnitedKingdom,
    label: "United Kingdom",
  },
  {
    value: Country.France,
    label: "France",
  },
  {
    value: Country.Netherlands,
    label: "Netherlands",
  },
];

export const MODEL_OPTIONS = [
  {
    value: "mix",
    label: "mix",
  },
  {
    value: "mm-euro1k",
    label: "mm-euro1k",
  },
];

export enum Parameter10yMean {
  "t_2m_10y_mean:C" = "t_2m_10y_mean:C",
  "t_2m_10y_mean:F" = "t_2m_10y_mean:F",
  "t_2m_10y_mean:K" = "t_2m_10y_mean:K",
  "wind_speed_10m_10y_mean:ms" = "wind_speed_10m_10y_mean:ms",
  "wind_speed_10m_10y_mean:kmh" = "wind_speed_10m_10y_mean:kmh",
}
// global_rad_10y_mean:W
export const COUNTRY_PLOT_PARAMETERS: { value: Parameter10yMean; label: string }[] = [
  {
    value: Parameter10yMean["t_2m_10y_mean:C"],
    label: Parameter10yMean["t_2m_10y_mean:C"],
  },
  {
    value: Parameter10yMean["t_2m_10y_mean:F"],
    label: Parameter10yMean["t_2m_10y_mean:F"],
  },
  {
    value: Parameter10yMean["t_2m_10y_mean:K"],
    label: Parameter10yMean["t_2m_10y_mean:K"],
  },
  {
    value: Parameter10yMean["wind_speed_10m_10y_mean:ms"],
    label: Parameter10yMean["wind_speed_10m_10y_mean:ms"],
  },
  {
    value: Parameter10yMean["wind_speed_10m_10y_mean:kmh"],
    label: Parameter10yMean["wind_speed_10m_10y_mean:kmh"],
  },
];
export function replace10yMeanFromParameterName(parameter: string): string {
  return parameter.replace(/_10y_mean/g, "");
}

export type CityCoordinates = { name: string; coordinates: { lat: number; lng: number } };
type CountryMapping = { [key in Country]?: CityCoordinates[] };

export const countryCityMapping: CountryMapping = {
  de: [
    { name: "Berlin", coordinates: { lat: 52.52, lng: 13.405 } },
    { name: "Hamburg", coordinates: { lat: 53.5511, lng: 9.9937 } },
    { name: "München", coordinates: { lat: 48.1351, lng: 11.582 } },
    { name: "Köln", coordinates: { lat: 50.9375, lng: 6.9603 } },
    { name: "Frankfurt am Main", coordinates: { lat: 50.1109, lng: 8.6821 } },
    { name: "Stuttgart", coordinates: { lat: 48.7758, lng: 9.1829 } },
    { name: "Düsseldorf", coordinates: { lat: 51.2277, lng: 6.7735 } },
    { name: "Leipzig", coordinates: { lat: 51.3397, lng: 12.3731 } },
    { name: "Dortmund", coordinates: { lat: 51.5139, lng: 7.4653 } },
    { name: "Essen", coordinates: { lat: 51.4566, lng: 7.0123 } },
    { name: "Bremen", coordinates: { lat: 53.0793, lng: 8.8017 } },
    { name: "Dresden", coordinates: { lat: 51.0504, lng: 13.7373 } },
    { name: "Hannover", coordinates: { lat: 52.3705, lng: 9.7332 } },
    { name: "Nürnberg", coordinates: { lat: 49.4521, lng: 11.0767 } },
    { name: "Duisburg", coordinates: { lat: 51.4344, lng: 6.7623 } },
  ],
  fr: [
    { name: "Paris", coordinates: { lat: 48.8566, lng: 2.3522 } },
    { name: "Marseille", coordinates: { lat: 43.2965, lng: 5.3698 } },
    { name: "Lyon", coordinates: { lat: 45.764, lng: 4.8357 } },
    { name: "Toulouse", coordinates: { lat: 43.6045, lng: 1.4442 } },
    { name: "Nice", coordinates: { lat: 43.7102, lng: 7.262 } },
    { name: "Nantes", coordinates: { lat: 47.2184, lng: -1.5536 } },
    { name: "Montpellier", coordinates: { lat: 43.6108, lng: 3.8767 } },
    { name: "Strasbourg", coordinates: { lat: 48.5734, lng: 7.7521 } },
    { name: "Bordeaux", coordinates: { lat: 44.8378, lng: -0.5792 } },
    { name: "Lille", coordinates: { lat: 50.6292, lng: 3.0573 } },
    { name: "Rennes", coordinates: { lat: 48.1173, lng: -1.6778 } },
    { name: "Reims", coordinates: { lat: 49.2628, lng: 4.0347 } },
    { name: "Toulon", coordinates: { lat: 43.1242, lng: 5.928 } },
    { name: "Saint-Étienne", coordinates: { lat: 45.4397, lng: 4.3872 } },
    { name: "Le Havre", coordinates: { lat: 49.4944, lng: 0.1079 } },
  ],
  uk: [
    { name: "London", coordinates: { lat: 51.5074, lng: -0.1278 } },
    { name: "Birmingham", coordinates: { lat: 52.4862, lng: -1.8904 } },
    { name: "Glasgow", coordinates: { lat: 55.8642, lng: -4.2518 } },
    { name: "Bristol", coordinates: { lat: 51.4545, lng: -2.5879 } },
    { name: "Liverpool", coordinates: { lat: 53.4084, lng: -2.9916 } },
    { name: "Manchester", coordinates: { lat: 53.4808, lng: -2.2426 } },
    { name: "Sheffield", coordinates: { lat: 53.3811, lng: -1.4701 } },
    { name: "Edinburgh", coordinates: { lat: 55.9533, lng: -3.1883 } },
    { name: "Leicester", coordinates: { lat: 52.6369, lng: -1.1398 } },
    { name: "Bradford", coordinates: { lat: 53.7959, lng: -1.7594 } },
    { name: "Coventry", coordinates: { lat: 52.4068, lng: -1.5197 } },
    { name: "Cardiff", coordinates: { lat: 51.4816, lng: -3.1791 } },
    { name: "Belfast", coordinates: { lat: 54.5973, lng: -5.9301 } },
    { name: "Nottingham", coordinates: { lat: 52.9548, lng: -1.1581 } },
  ],
  nl: [
    { name: "Amsterdam", coordinates: { lat: 52.3676, lng: 4.9041 } },
    { name: "Rotterdam", coordinates: { lat: 51.9225, lng: 4.4792 } },
    { name: "Den Haag", coordinates: { lat: 52.0705, lng: 4.3007 } },
    { name: "Utrecht", coordinates: { lat: 52.0907, lng: 5.1214 } },
    { name: "Eindhoven", coordinates: { lat: 51.4416, lng: 5.4697 } },
    { name: "Groningen", coordinates: { lat: 53.2194, lng: 6.5665 } },
    { name: "Tilburg", coordinates: { lat: 51.5606, lng: 5.0919 } },
    { name: "Almere", coordinates: { lat: 52.3508, lng: 5.2647 } },
    { name: "Breda", coordinates: { lat: 51.5719, lng: 4.7683 } },
    { name: "Nijmegen", coordinates: { lat: 51.8126, lng: 5.8372 } },
    { name: "Apeldoorn", coordinates: { lat: 52.2112, lng: 5.9699 } },
    { name: "Arnhem", coordinates: { lat: 51.9851, lng: 5.8987 } },
    { name: "Haarlem", coordinates: { lat: 52.3874, lng: 4.6462 } },
    { name: "Enschede", coordinates: { lat: 52.2215, lng: 6.8937 } },
    { name: "Haarlemmermeer", coordinates: { lat: 52.3024, lng: 4.6882 } },
  ],
};
